import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'
import Tabs from 'srcReact/components/common2/Tabs'
import PastMixrs from './components/PastMixrs'
import UpcomingMixrs from './components/UpcomingMixrs'
import MixrsPerDay from '../MixrsPerDay'

const Mixrs = ({ group, groupId, isMobile, dateForMixrs, setDateForMixrs }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.mixrsWrapper}>
      {dateForMixrs ? (
        <MixrsPerDay group={group} dateForMixrs={dateForMixrs} setDateForMixrs={setDateForMixrs} />
      ) : (
        <Tabs type='boxed'>
          <div label={t('groupHome.mixrs.upcoming')} onClick={() => {}}>
            <UpcomingMixrs groupId={groupId} isMobile={isMobile} />
          </div>
          <div label={t('groupHome.mixrs.past')} onClick={() => {}}>
            <PastMixrs groupId={groupId} isMobile={isMobile} />
          </div>
        </Tabs>
      )}
    </div>
  )
}

export default Mixrs
